/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_DismissInputs */

const en_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const de_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const fr_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer`)
};

const es_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const it_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora`)
};

const nl_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

const pl_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzuć`)
};

const fi_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohita`)
};

const da_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis`)
};

const sv_ats_tip_dismiss = /** @type {(inputs: Ats_Tip_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Ats_Tip_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_dismiss = /** @type {((inputs?: Ats_Tip_DismissInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_DismissInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_dismiss(inputs)
	if (locale === "fr") return fr_ats_tip_dismiss(inputs)
	if (locale === "es") return es_ats_tip_dismiss(inputs)
	if (locale === "it") return it_ats_tip_dismiss(inputs)
	if (locale === "nl") return nl_ats_tip_dismiss(inputs)
	if (locale === "pl") return pl_ats_tip_dismiss(inputs)
	if (locale === "fi") return fi_ats_tip_dismiss(inputs)
	if (locale === "da") return da_ats_tip_dismiss(inputs)
	if (locale === "sv") return sv_ats_tip_dismiss(inputs)
	return en_ats_tip_dismiss(inputs)
});